import { apiClient } from '../../gateways/api'
import type { JobSchedule } from '../types/JobSchedule'

export { createJobSchedule }

const createJobSchedule = async (
  job: Partial<JobSchedule>,
): Promise<JobSchedule> => {
  const { data } = await apiClient({
    url: '/rest/beheer/jobschedule',
    method: 'POST',
    data: {
      ...job,
    },
  })

  return data
}
